module.exports = __webpack_public_path__ + "img/badge_parchi_tematici.98ba69bc.jpg";